module.exports = __webpack_public_path__ + "static/loopio-logo-3d51c2114b43c3e5ac5660f7c017427b.png";